mutation UpsertParameter (
    $id: ID
    $definition: ParameterDefinition!
    $tier: EnumAccessTier
) {
    upsertParameter(
        id: $id
        definition: $definition
        tier: $tier
    ) {
        errors {
            message
            path
        }
        parameter {
            id

            name {
                language
                text
            }

            deprecated

            tier
            ownTier

            group {
                id
                tier
                name {
                    text
                }
            }
            sourceDefinition
        }
    }
}
